import buildRequest from '../buildRequest';

// Endpoints
import { typesEndpoint } from '../../../common/types';

// Libs
import { axios } from '../../../lib/axios';

// Utils
import { dataResponse, getApiRequest, handleError } from '../../../utils';

export const apiGetIdentidades = async () => {
  return getApiRequest({
    url: typesEndpoint.getIdentidades,
  });
};

export const apiPostIdentificacion = async params => {
  const url = typesEndpoint.personas;

  const request = {
    codigoIdentificacion: params.codigo,
    identificacion: params.identificacion,
  };

  try {
    const { status, data } = await axios.post(url, request, buildRequest());
    return dataResponse({ data: data.data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};
